/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { TableProps } from 'antd/es/table';
import { MTable } from '@Components/Base';
import { SortConfig } from '@Features/types/SortConfig';
import { RequestListContext } from '@Components/types/RequestListContext';
import { NoData } from '@Features/MaterialRequest/requests/components/NoData';

export interface RequestListProps {
  mapColumns: TableProps['columns'];
  dataSource: TableProps['dataSource'];
  totalItems?: number;
  pageSize?: number;
  currentPage?: number;
  onChangePage?: (page: number) => void;
  renderActionColumn?: (text: string, record: any) => JSX.Element;
  onSort?: (sortConfig: SortConfig | null) => void;
  rowSelection?: TableProps['rowSelection'];
  title?: TableProps['title'];
  hidePagination?: boolean;
  context?: RequestListContext;
  isSearchApplied?: boolean;
  isFiltersApplied?: boolean;
}

const RequestList: React.FC<RequestListProps> = (props): JSX.Element => {
  const {
    mapColumns,
    renderActionColumn,
    dataSource,
    totalItems,
    pageSize,
    currentPage,
    onChangePage,
    onSort,
    rowSelection,
    title,
    hidePagination = false,
    context = 'my-requests',
    isSearchApplied = false,
    isFiltersApplied = false,
  } = props;

  if (!dataSource || !dataSource.length || !mapColumns) {
    return (
      <NoData
        context={context}
        isSearchApplied={isSearchApplied}
        isFiltersApplied={isFiltersApplied}
      />
    );
  }

  const columns = [...mapColumns];

  if (renderActionColumn) {
    columns.push({
      title: 'ACTION',
      dataIndex: 'action',
      key: 'action',
      width: 80,
      fixed: 'right',
      render: renderActionColumn,
    });
  }

  return (
    <MTable
      title={title}
      rowSelection={rowSelection}
      columns={columns}
      dataSource={dataSource}
      totalItems={totalItems}
      pageSize={pageSize}
      currentPage={currentPage}
      onChangePage={onChangePage}
      onSort={onSort}
      hidePagination={hidePagination}
    />
  );
};

export default memo(RequestList) as typeof RequestList;
